/* eslint-disable no-useless-constructor */
// Right Chat - cliente do Kanban proprio.
// Arquivo NOVO com prefixo proprio: nunca colide com o upstream.
//
// A superficie aqui espelha exatamente docs/kanban-contrato.md. Dois detalhes que
// parecem detalhe e nao sao:
//   - PATCH de task vai SEMPRE com a raiz `task` (padrao Rails);
//   - `move` manda `board_step_id` na RAIZ, fora de `task`.
// Errar qualquer um dos dois devolve 400/422 silencioso na tela.
/* global axios */
import ApiClient from './ApiClient';

class RightKanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  // --- Boards ---------------------------------------------------------------
  getBoards() {
    return axios.get(`${this.url}/boards`);
  }

  getBoard(boardId) {
    return axios.get(`${this.url}/boards/${boardId}`);
  }

  createBoard(name) {
    return axios.post(`${this.url}/boards`, { board: { name } });
  }

  updateBoard(boardId, name) {
    return axios.patch(`${this.url}/boards/${boardId}`, { board: { name } });
  }

  deleteBoard(boardId) {
    return axios.delete(`${this.url}/boards/${boardId}`);
  }

  // --- Steps ----------------------------------------------------------------
  createStep(boardId, step) {
    return axios.post(`${this.url}/boards/${boardId}/steps`, { step });
  }

  updateStep(boardId, stepId, step) {
    return axios.patch(`${this.url}/boards/${boardId}/steps/${stepId}`, {
      step,
    });
  }

  deleteStep(boardId, stepId) {
    return axios.delete(`${this.url}/boards/${boardId}/steps/${stepId}`);
  }

  // --- Tasks ----------------------------------------------------------------
  getTasks(params = {}) {
    return axios.get(`${this.url}/tasks`, { params });
  }

  updateTask(taskId, task) {
    return axios.patch(`${this.url}/tasks/${taskId}`, { task });
  }

  moveTask(taskId, { boardStepId, insertBeforeTaskId = null }) {
    const payload = { board_step_id: boardStepId };
    if (insertBeforeTaskId) payload.insert_before_task_id = insertBeforeTaskId;
    return axios.post(`${this.url}/tasks/${taskId}/move`, payload);
  }
}

export default new RightKanbanAPI();
